import { getUreekaUrlRedirect } from '../utils/getUreekaUrlRedirect';
import { processMenu } from '../utils/menu';

export function getMarketingToolsMenu({
  businessEntityUuid,
  email,
  entitlements,
  order
}) {
  const registrationCode = entitlements.get('marketing_tools')?.registrationCode;

  return processMenu({
    title: 'Marketing Tools',
    icon: 'ureeka-fill.svg',
    show: entitlements.has('marketing_tools'),
    url: getUreekaUrlRedirect({ businessEntityUuid, email, registrationCode }),
    order
  });
}
